import { NativeDatePicker } from "components/base/Form";
import { useContext, useState } from "react";
import { GTMProjectContext } from "../GTMProjectContext";

const ProjectTimelineView = () => {
  const { originalGTMProject, autoSave } = useContext(GTMProjectContext);

  const [data, setData] = useState({
    timelinePackagingReadyDate: originalGTMProject.timelinePackagingReadyDate,
    timelineSampleForSalesDate: originalGTMProject.timelineSampleForSalesDate,
    timelineTrialOrderDate: originalGTMProject.timelineTrialOrderDate,
    timelineProductionStartDate: originalGTMProject.timelineProductionStartDate,
    timelineMarketLaunchDate: originalGTMProject.timelineMarketLaunchDate,
  });

  function onChange(values) {
    const newData = { ...data, ...values };
    setData(newData);
    autoSave({ id: originalGTMProject.id, input: newData });
  }

  return (
    <div className="card">
      <h5>
        Time line (<b className="text-orange-600">Jordan</b>)
      </h5>

      <div className="opacity-70">
        Please set the project timeline so that it aligns with the project's
        goals and objectives.
      </div>

      <div className="mt-2 -mx-2">
        <table>
          <tbody>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td className="py-1">Packaging Ready Date:</td>
              <td className="py-1 text-right">
                <NativeDatePicker
                  value={data.timelinePackagingReadyDate}
                  onChange={(e) => {
                    onChange({
                      timelinePackagingReadyDate: e.target.value,
                    });
                  }}
                />
              </td>
            </tr>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td className="py-1">Samples for Sales Date:</td>
              <td className="py-1 text-right">
                <NativeDatePicker
                  value={data.timelineSampleForSalesDate}
                  onChange={(e) =>
                    onChange({
                      timelineSampleForSalesDate: e.target.value,
                    })
                  }
                />
              </td>
            </tr>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td className="py-1">Trial Order Date:</td>
              <td className="py-1 text-right">
                <NativeDatePicker
                  value={data.timelineTrialOrderDate}
                  onChange={(e) =>
                    onChange({
                      timelineTrialOrderDate: e.target.value,
                    })
                  }
                />
              </td>
            </tr>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td className="py-1">Production Start Date:</td>
              <td className="py-1 text-right">
                <NativeDatePicker
                  value={data.timelineProductionStartDate}
                  onChange={(e) =>
                    onChange({
                      timelineProductionStartDate: e.target.value,
                    })
                  }
                />
              </td>
            </tr>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td className="py-1">Market Launch Date:</td>
              <td className="py-1 text-right">
                <NativeDatePicker
                  value={data.timelineMarketLaunchDate}
                  onChange={(e) =>
                    onChange({
                      timelineMarketLaunchDate: e.target.value,
                    })
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectTimelineView;
